import { getStats } from '../../api';
import { _apipe, _isOnPage, _isOnScreen, _once } from '../../utils';
import { animateValue } from '../../utils/animate-value';

const sitejabberRating = 4.8;
const reviewsioRating = 4.8;

type StatsResponse = {
  visitors_count: number;
  reviews_qty: number;
  writers_online: number;
  writers_count: number;
  returning_customers: number;
  returning_customers_avg: number;
  quality_score: number;
  years_on_market: number;
};

const setServiceStats = ({
  writers_count,
  returning_customers_avg,
  quality_score,
  years_on_market,
}: StatsResponse) => {
  const years = document.getElementById('years_on_market');
  const quality = document.getElementById('quality_score');
  const customers = document.getElementById('returning_customers');
  const writers = document.getElementById('writers_count');

  animateValue({ element: years, start: 0, end: years_on_market, duration: 1000, postfix: '+' });
  animateValue({
    element: customers,
    start: 0,
    end: returning_customers_avg,
    duration: 1000,
    postfix: 'K+',
    transformFn: (value: number) => value / 1000,
  });
  animateValue({
    element: quality,
    start: 0,
    end: quality_score,
    duration: 1000,
    postfix: '/10',
    transformFn: (value: number) => value.toFixed(2),
    useDecimals: true,
  });
  animateValue({ element: writers, start: 0, end: writers_count, duration: 1000 });
};

const setIntroStats = ({ returning_customers_avg, quality_score }: StatsResponse) => {
  const quality = document.getElementById('intro_quality_score');
  const customers = document.getElementById('intro_returning_customers');
  const sitejabber = document.getElementById('intro_sitejabber');
  const reviewsio = document.getElementById('intro_reviewsio');

  animateValue({
    element: customers,
    start: 0,
    end: returning_customers_avg,
    duration: 1000,
    postfix: '+',
  });
  animateValue({
    element: quality,
    start: 0,
    end: quality_score,
    duration: 1000,
    postfix: '/10',
    transformFn: (value: number) => value.toFixed(2),
    useDecimals: true,
  });
  animateValue({
    element: sitejabber,
    start: 0,
    end: sitejabberRating,
    duration: 1000,
    postfix: '/5',
    useDecimals: true,
    transformFn: (value: number) => value.toFixed(1),
  });
  animateValue({
    element: reviewsio,
    start: 0,
    end: reviewsioRating,
    duration: 1000,
    postfix: '/5',
    useDecimals: true,
    transformFn: (value: number) => value.toFixed(1),
  });
};

_isOnPage(
  '.js--stats',
  _once(() => {
    _apipe(getStats, (data: StatsResponse) => {
      _isOnScreen(
        '.js--service-stats',
        _once(() => {
          setServiceStats(data);
        }),
      );

      _isOnScreen(
        '.js--intro-stats',
        _once(() => {
          setIntroStats(data);
        }),
      );
    })();
  }),
);
